import React, { useState } from "react";
import VideoModal from "./VideoModal";

export default function Clients({ site = {}, clients = [], testimonials = [] }) {
  const [openVideo, setOpenVideo] = useState(null);

  // Выносим рендер списка клиентов в отдельную функцию для чистоты кода
  const renderClientLogos = (groupKey) => (
    <div className="flex shrink-0">
      {clients.map((c, i) => {
        const Wrap = c.link_url ? "a" : "div";
        const wrapProps = c.link_url
          ? { href: c.link_url, target: "_blank", rel: "noreferrer" }
          : {};
        return (
          <Wrap
            key={`${groupKey}-${c.id || c.name}-${i}`}
            data-testid={`client-logo-${groupKey}-${i}`}
            {...wrapProps}
            className="flex items-center px-4 py-6 sm:py-8 shrink-0 transition-opacity hover:opacity-100 opacity-90"
          >
            {c.logo_url ? (
              <img
                src={c.logo_url}
                alt={c.name}
                loading="lazy"
                className="h-20 sm:h-28 lg:h-32 w-auto"
                style={{ mixBlendMode: "screen" }}
              />
            ) : (
              <span className="font-display uppercase text-2xl sm:text-4xl lg:text-5xl tracking-tight text-white/55 px-6">
                {c.name}
              </span>
            )}
          </Wrap>
        );
      })}
    </div>
  );

  // РАСЧЕТ ВРЕМЕНИ ДЛЯ МЕДЛЕННОЙ АНИМАЦИИ (как в Team):
  // Берем минимум 60 секунд на цикл, либо умножаем количество клиентов на 12 секунд.
  // Это даст тот самый величественный, плавный ход без спешки.
  const calculatedDuration = Math.max(60, clients.length * 12);

  return (
    <section
      data-testid="clients-section"
      id="clients"
      className="bg-[#050505] border-t border-white/10"
    >
      <div className="px-5 sm:px-8 lg:px-12 pt-20 lg:pt-24 pb-8">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div>
            <p className="overline">Клиенты</p>
            <h2 data-testid="clients-title" className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl uppercase leading-[1] tracking-tight">
              {site.clients_title || "Наши клиенты"}
            </h2>
          </div>
          <p className="font-mono-jb text-[11px] uppercase tracking-[0.22em] text-white/40 max-w-md text-right">
            С нами работают бренды, агентства и арены.
          </p>
        </div>
      </div>

      {/* Single-row marquee */}
      <div className="border-y border-white/10 overflow-hidden flex">
        {clients.length === 0 ? null : (
          <div data-testid="clients-row-0" className="overflow-hidden w-full">
            <div
              className="flex w-max bbf-marquee-track"
              style={{ animationDuration: `${calculatedDuration}s` }}
            >
              {/* Две одинаковые группы для идеального зацикливания */}
              {renderClientLogos("group-1")}
              {renderClientLogos("group-2")}
            </div>
          </div>
        )}
      </div>

      {/* Testimonials */}
      <div className="px-5 sm:px-8 lg:px-12 py-20 lg:py-24">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <p className="overline">Отзывы</p>
            <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl uppercase leading-[1] tracking-tight">
              Слово <span className="bbf-accent-text">партнёров.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-[2px] bg-white/8 border border-white/10">
          {testimonials.map((t, i) => (
            <figure
              key={t.id || i}
              data-testid={`testimonial-${i}`}
              className="bg-[#050505] p-8 lg:p-10 flex flex-col justify-between min-h-[420px]"
            >
              <div>
                <span className="font-mono-jb text-[11px] uppercase tracking-[0.22em] text-[#a78bfa]">
                  {t.client}
                </span>
                <blockquote className="mt-6 text-white/85 text-base lg:text-[17px] leading-relaxed">
                  «{t.quote}»
                </blockquote>
              </div>

              {t.video_url && (
                <button
                  type="button"
                  data-testid={`testimonial-video-${i}`}
                  onClick={() => setOpenVideo(t)}
                  className="mt-6 relative w-full aspect-[16/9] overflow-hidden bg-[#0a0a0a] border border-white/10 group"
                >
                  {t.cover_url ? (
                    <img src={t.cover_url} alt={t.author} className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 opacity-80" />
                  ) : (
                    <div className="absolute inset-0 bbf-accent-gradient opacity-30" />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                  <span className="absolute inset-0 flex items-center justify-center">
                    <span className="w-14 h-14 flex items-center justify-center bbf-btn-primary text-white text-xl font-bold rounded-full">
                      ▶
                    </span>
                  </span>
                </button>
              )}

              <figcaption className="mt-8 pt-6 border-t border-white/10 font-mono-jb text-[11px] uppercase tracking-[0.22em] text-white/55">
                {t.author}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>

      {openVideo && (
        <VideoModal
          url={openVideo.video_url}
          title={openVideo.author}
          subtitle={openVideo.client}
          description={openVideo.quote}
          onClose={() => setOpenVideo(null)}
        />
      )}
    </section>
  );
}